export enum OrderItemStatusEnum {
  UNKNOWN = "unknown",
  INVOICED_RECEIVED = "invoice-received",
  GOODS_SHIPPED = "goods-shipped",
  INVOICE_SENT = "invoice-sent",
}
